import { inject } from '@angular/core';
import { CanMatchFn, UrlTree } from '@angular/router';
import { UserService } from '../services/user.service';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '@cumlaude/shared-authentication';
import { AutorisatieService } from '../services/autorisatie.service';

export const rolGuard: CanMatchFn = (_, segments, { queryParams }) => {
	const authService = inject(AuthService);
	if (!authService.isLoggedIn()) {
		return of(true); // auth-guard onthoudt route en doet de redirect
	}

	const userService = inject(UserService);
	const autorisatieService = inject(AutorisatieService);
	// instelling$ is nodig zodat userService.bron() (gebruikt in isBeheerAllowed) al is opgelost --
	// die hangt via een eigen switchMap-keten ná myAccount$ en zat hier eerder niet bij, waardoor een
	// harde navigatie naar bijv. /beheer/cijferinstellingen bij een verse pageload de guard soms met
	// bron() nog undefined liet evalueren en ten onrechte "Geen toegang" gaf.
	return combineLatest([userService.myAccount$, userService.rolChanged$, userService.rVestigingen$, userService.instelling$]).pipe(
		map(() => {
			const result = autorisatieService.checkUrlForActiveRol(`/${segments.join('/')}`);
			if (!(result instanceof UrlTree)) return result;

			return Object.assign(result, { queryParams: { ...queryParams, ...result.queryParams } });
		})
	);
};
